import PageHeader from "../components/PageHeader";
import Industries from "../components/Industries";

function IndustriesPage() {
  return (
    <>
      <PageHeader
        crumb="Industries"
        eyebrow="Domain Expertise"
        title="Industries We Serve"
        lead="Deep experience across sectors — we build software that understands the way your industry works."
      />
      <Industries />
    </>
  );
}

export default IndustriesPage;
